import { Controller } from "@hotwired/stimulus"

// Drives a native <dialog> (Dialog view component). The browser gives us the
// top layer, focus trapping and Escape handling for free — this only wires the
// open/close triggers and the click-outside-to-close behaviour.
//
//   <button data-action="dialog#open" data-dialog-target-id="my-dialog">…</button>
//
// Any element inside the dialog with data-action="dialog#close" closes it.
//
// `open: true` opens it as soon as it connects, which is how a dialog arriving
// in a Turbo Stream shows itself — there is no trigger to click in that case.
export default class extends Controller {
    static targets = ["dialog"]
    static values = {
        closeOnBackdrop: { type: Boolean, default: true },
        open: { type: Boolean, default: false },
    }

    connect() {
        if (this.openValue) this.open()
    }

    open() {
        if (!this.dialogTarget.open) this.dialogTarget.showModal()
    }

    close() {
        // Let the CSS exit transition finish before the browser removes the
        // dialog from the top layer (display/overlay are transitioned with
        // allow-discrete in the stylesheet).
        this.dialogTarget.close()
    }

    // Native <dialog> treats the backdrop as part of the element, so a click
    // outside the inner panel lands on the dialog itself.
    backdrop(event) {
        if (!this.closeOnBackdropValue) return
        if (event.target === this.dialogTarget) this.close()
    }
}
